import React from "react";
import { Card } from "react-bootstrap";

const SeoToolCard = ({ children }) => {

    if (!children) return null;

    return (
        <Card className="shadow-sm mb-2 rounded p-2 bg-white">
            <div style={{ overflowX: "auto", maxWidth: "100%" }}>
                {children}
            </div>
        </Card>
    );

};

export default SeoToolCard;